import { apiPaths } from 'app/services/api';
import React from 'react';
import CrudGridForm from '../../smart-kit/Form/CrudGridForm';

export const serviceCenterFields = [
  { label: 'Name', key: 'name', validation: { required: true } },
  { label: 'Address', key: 'address', validation: { required: true } },
  {
    label: 'City',
    key: 'city',
    validation: { required: true },
    // type: 'select',
  },
  {
    label: 'Phone Number',
    key: 'phone_number',
    validation: { required: true },
    // placeholder: '...0912',
  },

  {
    label: 'Location',
    key: 'location',
    type: 'location',
    validation: { required: false },
  },
];
const ServiceCenter = () => {
  return (
    <CrudGridForm
      path={apiPaths.SERVICE_CENTERS}
      name="Service Centers"
      entityName={'service_centers'}
      fields={serviceCenterFields}
    />
  );
};

export default ServiceCenter;
